import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eye, EyeOff } from "lucide-react";

export default function Reset() {
  const [p] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/reset-password", { token: p.get("token"), password }); nav("/login"); }
    catch (e2) { setErr(formatApiErr(e2.response?.data?.detail)); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-app)] p-6">
      <form onSubmit={submit} className="w-full max-w-md bg-white border rounded-xl p-8" data-testid="reset-form">
        <h2 className="text-2xl font-semibold mb-4">Reset password</h2>
        <Label htmlFor="reset-password">New password</Label>
        <div className="relative mt-1">
          <Input
            id="reset-password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="reset-password"
            className="pr-11"
            autoComplete="new-password"
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? "Hide password" : "Show password"}
            aria-pressed={showPassword}
            data-testid="reset-toggle-password"
            className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-zinc-400 hover:text-zinc-700"
            tabIndex={-1}
          >
            {showPassword ? <EyeOff className="w-4 h-4"/> : <Eye className="w-4 h-4"/>}
          </button>
        </div>
        {err && <div className="text-sm text-red-600 mt-2">{err}</div>}
        <Button className="w-full mt-4 bg-[var(--brand-primary)] text-white" type="submit" data-testid="reset-submit">Update password</Button>
        <div className="text-sm text-center mt-4"><Link to="/login" className="text-[var(--brand-accent)]">Sign in</Link></div>
      </form>
    </div>
  );
}
